import { FIELD } from '@server/parser';
import { ConfigurationToName } from '../types';
import { FunnelFieldLabels } from '../../../../constants/deprecated_fieldsManagementConsts';
import { getMetadataLabel } from '../../tabs/getMetadataLabel';
import { isCpqType } from '@server/documentation';

export const getItemType = ({
  parentType,
  dependencyType,
  saltoObjectTypes,
  _objectName,
}: {
  parentType: string;
  dependencyType: string;
  saltoObjectTypes: Pick<ObjectTypeName, 'objectType' | 'label'>[];
  _objectName?: string;
}) => {
  switch (parentType) {
    case FIELD:
      return FunnelFieldLabels[dependencyType as SweepFieldTypes] ?? dependencyType;

    default:
      if (isCpqType(parentType)) {
        return _objectName
          ? (saltoObjectTypes?.find((type) => type.objectType === _objectName)?.label ??
              _objectName) + ' Record'
          : '';
      }

      return ConfigurationToName[parentType] ?? getMetadataLabel(parentType);
  }
};
